<template>
    <span>
        <v-tooltip
            :disabled="!icon.description || !icon.description(value, item)"
            top>
            <template v-slot:activator="{ on, attrs }">
                <a class="icon--button" @click.stop="onClick">
                    <v-icon
                        v-if="icon.icon"
                        :color="icon.color && icon.color(value, item)"
                        v-bind="attrs"
                        v-on="on"
                    >{{ icon.icon(value, item) }}
                    </v-icon>
                    <img
                        v-else-if="icon.src"
                        :src="icon.src(value, item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                </a>
            </template>
            <span v-if="icon.description">{{ icon.description(value, item) }}</span>
        </v-tooltip>
        <v-menu
            v-model="menu"
            :close-on-content-click="menuOption.closeOnContentClick"
        >
            <template v-slot:activator="{ on, attrs }">
                <button ref="hiddenButton" v-on="on" v-bind="attrs" @click.stop="menu = !menu"></button>
            </template>
            <v-card>
                <component
                    :is="icon.component(value, item)"
                    v-if="icon.component"
                    :item="item"
                ></component>
                <span v-else>No Menu Content. Define component option!!</span>
            </v-card>
        </v-menu>
    </span>
</template>

<script>
export default {
    name: "VueDataTableIconMenu",
    props: {
        icon: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
        value: undefined,
        header: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            menu: false,
        };
    },
    computed: {
        menuOption() {
            return this.icon.menuOption || {};
        },
    },
    methods: {
        onClick() {
            this.$refs.hiddenButton.click();
        },
    },
}
</script>

<style scoped>
</style>